import "./AppointmentsAutharizationReleaseInformationAddComponent.scss";
import BackComponent from "../../../../shared/components/back/BackComponent";
import CardComponent from "../../../../shared/components/card/CardComponent";
import React, {useCallback} from "react";
import ClientRegistrationAuthorizationToReleaseMedicalInformationComponent
    from "../../../client-registration-authorization-to-release-medical-information/ClientRegistrationAuthorizationToReleaseMedicalInformationComponent";
import {useParams} from "react-router-dom";

interface AppointmentsAutharizationReleaseInformationAddComponentProps {

}

const AppointmentsAutharizationReleaseInformationAddComponent = (props: AppointmentsAutharizationReleaseInformationAddComponentProps) => {
    const params = useParams<{ appointmentId: string }>();
    const {appointmentId} = params;
    const handleBackNavigation = useCallback(() => {
        window.history.back();
    }, []);
    return (
        <div className={'appointments-autharization-release-information-add-Component appointment-form'}>
            <div className={'appointments-form-header'}>
                <BackComponent onClick={() => {
                    handleBackNavigation()
                }}/>
                {/*{appointmentDetails?.status === 'scheduled' && <>*/}
                {/*    <ButtonComponent onClick={handleRescheduleAppointment}>*/}
                {/*        Reschedule Appointment*/}
                {/*    </ButtonComponent>*/}
                {/*</>}*/}
            </div>
            <CardComponent>
                <ClientRegistrationAuthorizationToReleaseMedicalInformationComponent mode={"add"}
                                                                                     onNext={handleBackNavigation}
                                                                                     appointmentId={appointmentId}
                />
            </CardComponent>
        </div>
    );

};

export default AppointmentsAutharizationReleaseInformationAddComponent;
